import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["viewBox"]
const _hoisted_2 = ["fill"]
const _hoisted_3 = ["fill"]

import { PropType } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'bellIcon',
  props: {
  color: {
    type: String as PropType<string>,
    default: "#000000",
  },
  width: {
    type: Number as PropType<number>,
    default: 17,
  },
  height: {
    type: Number as PropType<number>,
    default: 21,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    style: _normalizeStyle(`max-width: ${__props.width}px; max-height: ${__props.height}px; min-width: ${__props.width}px; min-height: ${__props.height}px; display: flex; align-items: center;`)
  }, [
    (_openBlock(), _createElementBlock("svg", {
      style: {"width":"100%","height":"100%"},
      viewBox: `0 0 ${__props.width} ${__props.height}`,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, [
      _createElementVNode("path", {
        d: "M15.5195 14.7078C15.1947 14.7078 14.8833 14.5788 14.6536 14.3491C14.4239 14.1194 14.2949 13.808 14.2949 13.4832V9.51544C14.3359 7.96621 13.8246 6.45291 12.8524 5.24596C11.8803 4.03901 10.5107 3.21708 8.98828 2.92704V1.23708C8.98828 1.02055 8.90227 0.812895 8.74916 0.659789C8.59605 0.506684 8.3884 0.42067 8.17187 0.42067C7.95535 0.42067 7.74769 0.506684 7.59459 0.659789C7.44148 0.812895 7.35547 1.02055 7.35547 1.23708V2.92704C5.83309 3.21708 4.46344 4.03901 3.4913 5.24596C2.51917 6.45291 2.00788 7.96621 2.04883 9.51544V13.4832C2.04883 13.808 1.91981 14.1194 1.69015 14.3491C1.46049 14.5788 1.14901 14.7078 0.824219 14.7078C0.607694 14.7078 0.400038 14.7938 0.246932 14.9469C0.0938264 15.1 0.0078125 15.3077 0.0078125 15.5242C0.0078125 15.7407 0.0938264 15.9484 0.246932 16.1015C0.400038 16.2546 0.607694 16.3406 0.824219 16.3406H15.5195C15.7361 16.3406 15.9437 16.2546 16.0968 16.1015C16.2499 15.9484 16.3359 15.7407 16.3359 15.5242C16.3359 15.3077 16.2499 15.1 16.0968 14.9469C15.9437 14.7938 15.7361 14.7078 15.5195 14.7078Z",
        fill: __props.color
      }, null, 8, _hoisted_2),
      _createElementVNode("path", {
        d: "M10.001 17.5649H6.3435C6.29477 17.5665 6.24823 17.5855 6.21229 17.6184C6.17635 17.6514 6.15339 17.6961 6.14756 17.7445C6.14352 17.8206 6.14352 17.8969 6.14756 17.9731C6.14756 18.5144 6.3626 19.0335 6.74536 19.4163C7.12813 19.7991 7.64727 20.0141 8.18858 20.0141C8.72989 20.0141 9.24903 19.7991 9.6318 19.4163C10.0146 19.0335 10.2296 18.5144 10.2296 17.9731C10.2336 17.8969 10.2336 17.8206 10.2296 17.7445C10.2266 17.7176 10.2182 17.6916 10.2051 17.668C10.1919 17.6443 10.1741 17.6236 10.1529 17.6069C10.1316 17.5901 10.1072 17.5778 10.0812 17.5706C10.0551 17.5634 10.0278 17.5615 10.001 17.5649Z",
        fill: __props.color
      }, null, 8, _hoisted_3)
    ], 8, _hoisted_1))
  ], 4))
}
}

})